export function mapRecipientStatusLabel(status: string): string {
  switch (status) {
    case 'pending':
      return 'Pendente';
    case 'sent':
      return 'Convite enviado';
    case 'delivered':
      return 'Entregue';
    case 'completed':
      return 'Assinado';
    case 'declined':
      return 'Recusado';
    case 'not_applicable':
      return '—';
    default:
      return status;
  }
}

export function mapEnvelopeStatusLabel(
  status: string,
  failureSubtype?: string | null
): string {
  switch (status) {
    case 'sent':
      return 'Aguardando assinaturas';
    case 'delivered':
      return 'Aguardando assinaturas';
    case 'completed':
      return 'Concluída';
    case 'declined':
      return 'Recusada';
    case 'voided':
      return 'Cancelada';
    case 'failed':
      if (failureSubtype === 'failed_create') return 'Falha ao criar envelope';
      if (failureSubtype === 'failed_download') return 'Falha ao baixar documentos';
      if (failureSubtype === 'failed_webhook') return 'Falha no processamento';
      return 'Falha na assinatura';
    default:
      return status;
  }
}

export function canRetryDocusignSignature(
  signature: { status: string; failureSubtype?: string | null } | null | undefined
): boolean {
  if (!signature) return false;
  return (
    signature.status === 'failed' &&
    signature.failureSubtype !== 'failed_create'
  );
}

export function canSyncDocusignSignature(
  signature: { status: string; failureSubtype?: string | null } | null | undefined
): boolean {
  if (!signature) return false;
  return (
    signature.status === 'sent' ||
    signature.status === 'delivered' ||
    signature.status === 'failed'
  );
}

/**
 * O envio para assinatura não falhou, só não respondeu a tempo: 409 é outra
 * chamada da mesma proposta ainda criando os envelopes; 503/504 é o API Gateway
 * cortando em 30s enquanto o servidor segue criando.
 */
export function isSignatureSubmissionStillRunning(error: unknown): boolean {
  const statusCode = (error as { statusCode?: number } | null)?.statusCode;
  return statusCode === 409 || statusCode === 503 || statusCode === 504;
}

export function areAllPmeSignaturesCompleted(
  envelopes: Array<{ envelopeKind?: string; status: string }> | null | undefined,
  requiredKinds: string[] = ['proposal', 'commercial_letter']
): boolean {
  if (!envelopes?.length) return false;
  return requiredKinds.every(kind =>
    envelopes.some(
      envelope => envelope.envelopeKind === kind && envelope.status === 'completed'
    )
  );
}
